/*
 * Globalize Culture pl-PL
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function (window, undefined) {

    var Globalize;

    if (typeof require !== "undefined" &&
        typeof exports !== "undefined" &&
        typeof module !== "undefined") {
        // Assume CommonJS
        Globalize = require("globalize");
    } else {
        // Global variable
        Globalize = window.Globalize;
    }

    Globalize.addCultureInfo("pl-PL", "default", {
        name: "pl-PL",
        englishName: "Polish (Poland)",
        nativeName: "polski (Polska)",
        language: "pl",
        numberFormat: {
            ",": " ",
            ".": ",",
            "NaN": "nie jest liczbą",
            negativeInfinity: "-nieskończoność",
            positiveInfinity: "+nieskończoność",
            percent: {
                pattern: ["-n%", "n%"],
                ",": " ",
                ".": ","
            },
            currency: {
                pattern: ["-n $", "n $"],
                ",": " ",
                ".": ",",
                symbol: "zł"
            }
        },
        calendars: {
            standard: {
                "/": ".",
                firstDay: 1,
                days: {
                    names: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"],
                    namesAbbr: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
                    namesShort: ["N", "Pn", "Wt", "Śr", "Cz", "Pt", "So"]
                },
                months: {
                    names: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień", ""],
                    namesAbbr: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru", ""]
                },
                monthsGenitive: {
                    names: ["stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca", "lipca", "sierpnia", "września", "października", "listopada", "grudnia", ""],
                    namesAbbr: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru", ""]
                },
                AM: null,
                PM: null,
                patterns: {
                    d: "yyyy.MM.dd",
                    D: "d MMMM yyyy",
                    t: "HH:mm",
                    T: "HH:mm:ss",
                    f: "d MMMM yyyy HH:mm",
                    F: "d MMMM yyyy HH:mm:ss",
                    M: "d MMMM",
                    Y: "MMMM yyyy"
                }
            }
        }
    });

}(this));

$.extend($.validator.messages, {
        required: "Pole wymagane.",
        remote: "Niepoprawna wartość.",
        email: "Proszę wprowadzić prawidłowy adres email.",
        url: "Proszę wprowadzić adres URL.",
        date: "Proszę wprowadzić datę.",
        dateISO: "Proszę wprowadzić poprawną datę.",
        number: "Proszę wprowadzić numer.",
        digits: "Proszę wprowadzić wyłącznie cyfry.",
        creditcard: "Proszę wprowadzić poprawny numer karty kredytowej.",
        equalTo: "Proszę wprowadzić tą samą wartość raz jeszcze.",
        maxlength: $.validator.format("Proszę wprowadzić nie więcej niż {0} znaków."),
        minlength: $.validator.format("Proszę wprowadzić nie mniej niż {0} znaków."),
        rangelength: $.validator.format("Proszę wprowadzić od {0} do {1} znaków."),
        range: $.validator.format("Proszę wprowadzić wartość z zakresu od {0} do {1}."),
        max: $.validator.format("Proszę wprowadzić wartość mniejszą lub równą {0}."),
        min: $.validator.format("Proszę wprowadzić wartość większą lub równą {0}.")
});

ErrorHandling.messages = {
    ajaxErrorTitle: "Błąd Ajax",
    ajaxErrorBody: $.validator.format("Wystąpił błąd podczas realizowania żądania AJAX.<br/> " +
        "Poniżej znajdują się szczegóły błędu. Jeżeli będzie się on powtarzał, " +
        "skontaktuj się z administratorem.<br/><br/>" +
        "Typ żądania: {0}<br/>" +
        "<span class='break-all'>Url: {1}</span><br/>"),
    ajaxErrorExceptionClass: $.validator.format("Klasa wyjątku: {0}<br/>"),
    ajaxErrorExceptionMessage: $.validator.format("Oryginalna wiadomość: {0}"),
    jsErrorTitle: "Błąd JavaScript",
    jsErrorBody: $.validator.format("Wystąpił błąd JavaScript podczas przetwarzania bieżącego dokumentu. " +
        "Poniżej znajdują się szczegóły błędu. Jeżeli będzie się on powtarzał, " +
        "skontaktuj się z administratorem.<br/><br/>" +
        "Opis: {0}<br/>" +
        "<span class='break-all'>Źródło: {1}</span><br/>" +
        "Linia: {2}")
}

eRMap.messages = {
    determineWayError: "Nie można wyznaczyć trasy z powodu błędnego adresu początkowego.",
    showMarkersError: "Nie można wyświetlić lokalizacji placówki z powodu błędnego adresu.",
    initialAddress: "Adres początkowy...",
    print: "Drukuj",
    printingMap: "Drukowanie mapy",
    setRoute: "Wyznacz trasę",
    traffic: "Natężenie ruchu",
    language: "pl",
}